import React from "react";

import "./src/styles/global.css";
import Layout from "./src/components/Layout";
import AdminLayout from "./src/components/AdminLayout";
import LoginLayout from "./src/components/LoginLayout";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  const path = props.path || "";

  // Use AdminLayout for admin pages
  if (path.startsWith("/admin")) {
    return <AdminLayout {...props}>{element}</AdminLayout>;
  }

  // Use LoginLayout for login page
  if (path === "/login" || path === "/login/") {
    return <LoginLayout {...props}>{element}</LoginLayout>;
  }

  // Use regular Layout for all other pages
  return <Layout {...props}>{element}</Layout>;
};
